module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cross-profile-table"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%",
      "text-align": "center"
    },
    attrs: {
      "data": _vm.platforms,
      "border": true,
      "max-height": "600"
    }
  }, [_c('el-table-column', {
    attrs: {
      "width": "50",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_c('SocialIcon', {
          attrs: {
            "fontSize": '12px',
            "type": _vm.channelIconList[scope.row.platform].name
          }
        })], 1)]
      }
    }])
  }), _vm._v(" "), _vm._l((_vm.platforms), function(column, index) {
    return _c('el-table-column', {
      key: index,
      attrs: {
        "fixed": false,
        "label": _vm.channelIconList[column.platform].name,
        "width": "50",
        "align": "center"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('span', [_c('cross-platform-engagement-cell-block', {
            attrs: {
              "first_platform": column.platform,
              "second_platform": _vm.platforms[scope.$index].platform,
              "isCross": true,
              "percentage": _vm.platforms[scope.$index].engagement[column.platform]
            }
          })], 1)]
        }
      }], null, true)
    }, [_c('template', {
      attrs: {
        "fixed": ""
      },
      slot: "header"
    }, [_c('SocialIcon', {
      attrs: {
        "fontSize": '18px',
        "type": _vm.channelIconList[column.platform].name
      }
    })], 1)], 2)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "uniques",
      "label": "Uniques"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.formatUniquesNumber(scope)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "percentage",
      "label": "",
      "min-width": "120px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_c('el-progress', {
          attrs: {
            "text-inside": true,
            "stroke-width": 24,
            "color": '#6f7ad3',
            "percentage": _vm.getLinePercentage(scope.row.uniques, _vm.totalUniques)
          }
        })], 1)]
      }
    }])
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cb840904","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/profiles/charts/CrossProfileTable.vue
// module id = 3395
// module chunks = 3